/**
 * 高德地图key和密钥
 */
const MAP_KEY = {
  development: {
    appkey: '0ec2b0d501072425eb017f8907767652',
    secretkey: 'd3005767e17991ee37e881e0f758d713'
  },
  test: {
    appkey: '0ec2b0d501072425eb017f8907767652',
    secretkey: 'd3005767e17991ee37e881e0f758d713'
  },
  pre: {
    appkey: '0ec2b0d501072425eb017f8907767652',
    secretkey: 'd3005767e17991ee37e881e0f758d713'
  },
  production: {
    appkey: 'dff6dfa339a9fb73cff92d20902d1134',
    secretkey: '5067712c109dcb7a5b967f1b7d216360'
  }
}

/**
 * 高德地图key和密钥
 */
export function getMapKey() {
  return MAP_KEY[process.env.NODE_ENV] || MAP_KEY['production']
}
